import qs from 'qs'
import { ONLINE_APPOINTMENT_API, QUOTE_APPOINTMENT_API } from './constants'

export const isQuickAppointment = ({ search = '' }) => {
  const { isFromOnlineAppointment = '' } = qs.parse(search.slice(1))

  return isFromOnlineAppointment.toLowerCase() !== 'false'
}

export const getAppointmentMethod = ({ search = '' }) =>
  isQuickAppointment({ search }) ?
    ONLINE_APPOINTMENT_API : QUOTE_APPOINTMENT_API

